export default "__VITE_ASSET__$YvySQyA__"